import React from 'react';
import { NewMealXlsProvider } from 'contexts/new-meal-xls.context';
import NewMealXlsContent from './content';

const NewMealXlsLayout = () => {
  return (
    <NewMealXlsProvider>
      <NewMealXlsContent />
    </NewMealXlsProvider>
  );
};

export default NewMealXlsLayout;
